exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-apply-modal-required {\n  position: relative;\n}\n.app-apply-modal-required .ant-form-item-control-wrapper:after {\n  content: '*';\n  color: #f00;\n  position: absolute;\n  top: 11px;\n  font-size: 14px;\n  right: -9px;\n}\n.app-apply-modal .ant-modal-body {\n  padding: 24px 45px;\n}\n.app-apply-modal .ant-modal-body .ant-form label {\n  font-size: 12px;\n}\n.app-apply-modal .ant-modal-body .ant-form label:before {\n  content: '';\n  margin-right: 0;\n}\n.app-apply-modal .ant-modal-body .ant-form-item-label {\n  text-align: left;\n}\n.app-apply-modal .ant-modal-body .ant-form-item {\n  margin-bottom: 10px;\n}\n.app-apply-modal-tip {\n  font-size: 12px;\n  margin-bottom: 5px;\n}\n.app-apply-modal-help-tip {\n  position: absolute;\n  top: -11px;\n  right: -26px;\n}\n.app-apply-modal-alert {\n  margin-top: 30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#1DA57A"}}!./src/components/util/appApply/style/app.less
// module id = 1122
// module chunks = 0